import { A4uAddCircle as IconComponent } from '@adobe/react-spectrum-workflow/dist/AddCircle.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function AddCircle(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}